import React from 'react';
import { PaymentLogo } from '../PaymentLogo';

export function PayPalButton({ onClick, disabled, loading, label }) {
  return (
    <button
      type="button"
      className="w-100 p-12 rounded-2 nc-realtextpro-copy fw-bold bg-warning border-0 d-flex justify-content-center align-items-center"
      onClick={onClick}
      disabled={disabled}
    >
      <PaymentLogo icon="iconPaypal" bgClassName="" ariaLabel="PayPal" width={75} height={20}/>
    </button>
  );
}

export default PayPalButton;
